import {isNumber} from 'ramda-adjunct';

import type {CellValues} from '../types/CellValues';

export const isCurrencyCellValue = (value: any): value is CellValues =>
  isNumber(value?.amount) && 'currency' in value;
